export default __webpack_public_path__ + "static/media/search_without_result.00d9a4f1.png";